<template>
    <v-form ref="formFiltro" v-on:submit.prevent="filtrar">
        <v-row>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <MesInput
                    label="Período Inicial"
                    v-model="filtro.dataInicial"
                    :rules="regra.dataInicial"
                    :change="periodoInicialChange"
                    required
                ></MesInput>
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <MesInput
                    label="Período Final"
                    v-model="filtro.dataFinal"
                    :rules="regra.dataFinal"
                    :change="periodoFinalChange"
                    required
                ></MesInput>
            </v-col>

            <v-col sm="6" md="4" lg="3" class="pb-0">
                <v-select
                    label="Visão"
                    :items="listaLocal.visao"
                    v-model="filtro.visao"
                    :rules="regra.visao"
                    :menu-props="menuProps"
                    class="input-cinza"
                    multiple
                    outlined
                    dense
                >
                    <template v-slot:selection="{ item, index }">
                        <span v-if="filtro.visao.length === 1 && index === 0">{{
                            item.text
                        }}</span>
                        <span
                            v-if="filtro.visao.length > 1 && index === 0"
                            class="grey--text caption mr-1"
                            >{{ filtro.visao.length }} selecionados</span
                        >
                    </template>
                </v-select>
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <v-select
                    label="Colunas Agrupadas"
                    :items="listaLocal.cols_agrupado"
                    v-model="filtro.agrupar"
                    :menu-props="menuProps"
                    class="input-cinza"
                    return-object
                    multiple
                    outlined
                    dense
                >
                    <template v-slot:selection="{ item, index }">
                        <span
                            v-if="filtro.agrupar.length === 1 && index === 0"
                            >{{ item.text }}</span
                        >
                        <span
                            v-if="filtro.agrupar.length > 1 && index === 0"
                            class="grey--text caption mr-1"
                            >{{ filtro.agrupar.length }} selecionados</span
                        >
                    </template>
                </v-select>
            </v-col>
        </v-row>
        <v-expansion-panels flat v-model="mostrarFiltros" accordion>
            <v-expansion-panel>
                <v-expansion-panel-content eager class="p-0 m-0">
                    <v-row>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-select
                                label="Bandeira"
                                v-model="filtro.bandeira"
                                :items="listaLocal.bandeira"
                                class="input-cinza"
                                multiple
                                outlined
                                dense
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span
                                        v-if="
                                            filtro.bandeira.length === 1 &&
                                            index === 0
                                        "
                                        >{{ item.text }}</span
                                    >
                                    <span
                                        v-if="
                                            filtro.bandeira.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.bandeira.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-select>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-autocomplete
                                label="Fornecedor"
                                v-model="filtro.id_fornecedor"
                                :items="lista.fornecedor"
                                :rules="regra.fornecedor"
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                multiple
                            >
                                <template v-slot:selection="{ item, index }">
                                    <div
                                        v-if="
                                            filtro.id_fornecedor.length === 1 &&
                                            index === 0
                                        "
                                        class="autocomplete-selecao"
                                    >
                                        {{ item.text }}
                                    </div>
                                    <span
                                        v-if="
                                            filtro.id_fornecedor.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.id_fornecedor.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-autocomplete
                                label="Macro Fornecedor"
                                v-model="filtro.id_macrofornecedor"
                                :items="lista.macrofornecedor"
                                :rules="regra.macrofornecedor"
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                multiple
                            >
                                <template v-slot:selection="{ item, index }">
                                    <div
                                        v-if="
                                            filtro.id_macrofornecedor.length ===
                                                1 && index === 0
                                        "
                                        class="autocomplete-selecao"
                                    >
                                        {{ item.text }}
                                    </div>
                                    <span
                                        v-if="
                                            filtro.id_macrofornecedor.length >
                                                1 && index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.id_macrofornecedor.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-autocomplete
                                label="Espaço"
                                v-model="filtro.id_espaco"
                                :items="lista.espaco"
                                :menu-props="menuProps"
                                class="input-cinza"
                                multiple
                                outlined
                                dense
                            >
                                <template v-slot:selection="{ item, index }">
                                    <div
                                        v-if="
                                            filtro.id_espaco.length === 1 &&
                                            index === 0
                                        "
                                        class="autocomplete-selecao"
                                    >
                                        {{ item.text }}
                                    </div>
                                    <span
                                        v-if="
                                            filtro.id_espaco.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.id_espaco.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-autocomplete
                                label="Espaço Macro"
                                v-model="filtro.espaco_macro"
                                :items="lista.espaco_macro"
                                :menu-props="menuProps"
                                class="input-cinza"
                                multiple
                                outlined
                                dense
                            >
                                <template v-slot:selection="{ item, index }">
                                    <div
                                        v-if="
                                            filtro.espaco_macro.length === 1 &&
                                            index === 0
                                        "
                                        class="autocomplete-selecao"
                                    >
                                        {{ item.text }}
                                    </div>
                                    <span
                                        v-if="
                                            filtro.espaco_macro.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.espaco_macro.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-select
                                label="Status"
                                :items="lista.status"
                                v-model="filtro.id_status"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span
                                        v-if="
                                            filtro.id_status.length === 1 &&
                                            index === 0
                                        "
                                        >{{ item.text }}</span
                                    >
                                    <span
                                        v-if="
                                            filtro.id_status.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.id_status.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-select>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-select
                                label="BU"
                                :items="lista.bu"
                                v-model="filtro.bu"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span
                                        v-if="
                                            filtro.bu.length === 1 &&
                                            index === 0
                                        "
                                        >{{ item.text }}</span
                                    >
                                    <span
                                        v-if="
                                            filtro.bu.length > 1 && index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.bu.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-select>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-select
                                label="Comprador"
                                :items="lista.comprador"
                                v-model="filtro.comprador"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span
                                        v-if="
                                            filtro.comprador.length === 1 &&
                                            index === 0
                                        "
                                        >{{ item.text }}</span
                                    >
                                    <span
                                        v-if="
                                            filtro.comprador.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.comprador.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-select>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-select
                                label="Analista"
                                :items="lista.analista"
                                v-model="filtro.analista"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span
                                        v-if="
                                            filtro.analista.length === 1 &&
                                            index === 0
                                        "
                                        >{{ item.text }}</span
                                    >
                                    <span
                                        v-if="
                                            filtro.analista.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.analista.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-select>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-autocomplete
                                label="Usuario"
                                v-model="filtro.id_usuario_criacao"
                                :items="lista.usuarios"
                                :menu-props="menuProps"
                                class="input-cinza"
                                multiple
                                outlined
                                dense
                            >
                                <template v-slot:selection="{ item, index }">
                                    <div
                                        v-if="
                                            filtro.id_usuario_criacao.length ===
                                                1 && index === 0
                                        "
                                        class="autocomplete-selecao"
                                    >
                                        {{ item.text }}
                                    </div>
                                    <span
                                        v-if="
                                            filtro.id_usuario_criacao.length >
                                                1 && index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.id_usuario_criacao.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-autocomplete
                                label="Ativação (Planejamento)"
                                v-model="filtro.id_ativacao"
                                :items="lista.ativacao"
                                :menu-props="menuProps"
                                class="input-cinza"
                                multiple
                                outlined
                                dense
                            >
                                <template v-slot:selection="{ item, index }">
                                    <div
                                        v-if="
                                            filtro.id_ativacao.length === 1 &&
                                            index === 0
                                        "
                                        class="autocomplete-selecao"
                                    >
                                        {{ item.text }}
                                    </div>
                                    <span
                                        v-if="
                                            filtro.id_ativacao.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.id_ativacao.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-autocomplete
                                label="Categoria (Planejamento)"
                                v-model="filtro.id_categoria"
                                :items="lista.categoria"
                                :menu-props="menuProps"
                                class="input-cinza"
                                multiple
                                outlined
                                dense
                            >
                                <template v-slot:selection="{ item, index }">
                                    <div
                                        v-if="
                                            filtro.id_categoria.length === 1 &&
                                            index === 0
                                        "
                                        class="autocomplete-selecao"
                                    >
                                        {{ item.text }}
                                    </div>
                                    <span
                                        v-if="
                                            filtro.id_categoria.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.id_categoria.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-autocomplete
                                label="Semana (Planejamento)"
                                v-model="filtro.semana"
                                :items="listaLocal.semana"
                                :menu-props="menuProps"
                                class="input-cinza"
                                multiple
                                outlined
                                dense
                            >
                                <template v-slot:selection="{ item, index }">
                                    <div
                                        v-if="
                                            filtro.semana.length === 1 &&
                                            index === 0
                                        "
                                        class="autocomplete-selecao"
                                    >
                                        {{ item.text }}
                                    </div>
                                    <span
                                        v-if="
                                            filtro.semana.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.semana.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <v-autocomplete
                                label="Área (Planejamento)"
                                v-model="filtro.id_area"
                                :items="lista.area"
                                :menu-props="menuProps"
                                class="input-cinza"
                                multiple
                                outlined
                                dense
                            >
                                <template v-slot:selection="{ item, index }">
                                    <div
                                        v-if="
                                            filtro.id_area.length === 1 &&
                                            index === 0
                                        "
                                        class="autocomplete-selecao"
                                    >
                                        {{ item.text }}
                                    </div>
                                    <span
                                        v-if="
                                            filtro.id_area.length > 1 &&
                                            index === 0
                                        "
                                        class="grey--text caption mr-1"
                                        >{{
                                            filtro.id_area.length
                                        }}
                                        selecionados</span
                                    >
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-divider class="mt-0 mb-3"></v-divider>
        <v-row>
            <v-col cols="3" class="px-2 ml-auto">
                <div class="new-button d-flex align-center" text>
                    <span @click="expandirFiltros" style="cursor: pointer"
                        >Personalizar Filtros</span
                    >
                    <v-btn
                        style="background: #e6e6e6; width: 20px; height: 20px"
                        fab
                        icon
                        class="ml-3"
                        @click="expandirFiltros"
                        x-small
                    >
                        <v-icon>{{
                            mostrarFiltros == 0
                                ? 'mdi-chevron-up'
                                : 'mdi-chevron-down'
                        }}</v-icon>
                    </v-btn>
                </div>
            </v-col>

            <v-col
                cols="9"
                class="ml-auto d-flex align-center justify-end"
                align="end"
            >
                <v-checkbox
                    label="Planejado X Realizado "
                    class="mt-0"
                    v-model="filtro.planejado_realizado"
                    hide-details
                    dense
                ></v-checkbox>
                <v-btn
                    class="mx-5 new-button"
                    color="yellow"
                    dark
                    @click="limpar()"
                >
                    <v-icon left>mdi-filter-off</v-icon> Limpar Filtros
                </v-btn>
                <v-btn class="new-button" color="primary" type="submit">
                    <v-icon left>mdi-filter</v-icon> Filtrar
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import useFiltros from '../../hooks/useFiltros'

export default {
    setup() {
        const { isLoading, isError, isFetching, lista, error, refetch } =
            useFiltros('/simulacao/gerencial/filtros')

        return { isLoading, isError, isFetching, lista, error, refetch }
    },
    inject: ['listaCampos'],
    data() {
        return {
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: 'select-outline',
                transition: 'slide-y-transition',
            },
            mostrarFiltros: null,
            listaLocal: {
                cols_agrupado: [
                    { text: 'Status', value: 'status', ordem: 1 },
                    { text: 'Espaço Macro', value: 'espaco_macro', ordem: 2 },
                    { text: 'Espaço/Ativação', value: 'espaco', ordem: 3 },
                    { text: 'Bandeira', value: 'bandeira', ordem: 4 },
                    { text: 'Fornecedor', value: 'fornecedor', ordem: 5 },
                    { text: 'Neogrupo', value: 'grupo', ordem: 6 },
                    { text: 'BU', value: 'bu', ordem: 7 },
                    { text: 'Comprador', value: 'comprador', ordem: 8 },
                    { text: 'Analista', value: 'analista', ordem: 9 },
                    {
                        text: 'Categoria (Planejamento)',
                        value: 'categoria',
                        ordem: 11,
                    },
                    {
                        text: 'Semana (Planejamento)',
                        value: 'semana',
                        ordem: 12,
                    },
                    { text: 'Área (Planejamento)', value: 'area', ordem: 13 },
                    { text: 'Ação (Planejamento)', value: 'acao', ordem: 14 },
                ],
                visao: [
                    { text: 'PDV', value: 'pdv' },
                    { text: 'Campanha', value: 'campanha' },
                    { text: 'E-commerce', value: 'ecommerce' },
                    {
                        text: 'Planejamento E-commerce',
                        value: 'planejamento_ecommerce',
                    },
                ],
                bandeira: [
                    { text: 'DROGASIL', value: 'DROGASIL' },
                    { text: 'RAIA', value: 'RAIA' },
                ],
                semana: [
                    { text: 'Semana 1', value: 1 },
                    { text: 'Semana 2', value: 2 },
                    { text: 'Semana 3', value: 3 },
                    { text: 'Semana 4', value: 4 },
                    { text: 'Semana 5', value: 5 },
                ],
            },

            filtro: {
                visao: 'pdv',
                dataInicial: this.$moment().format('YYYY-MM'),
                dataFinal: this.$moment().format('YYYY-MM'),
                id_fornecedor: [],
                planejado_realizado: false,
            },
            regra: {
                dataInicial: [
                    (v) => !!v || 'O campo período inicial é obrigatório',
                ],
                dataFinal: [
                    (v) => !!v || 'O campo período final é obrigatório',
                    (v) =>
                        (!!v && v >= this.filtro.dataInicial) ||
                        'O período final deve ser igual ou posterior ao período inicial',
                ],
                visao: [(v) => v.length > 0 || 'O campo visão é obrigatório'],
            },
        }
    },
    async created() {
        this.iniciaFiltro()
    },
    computed: {},
    methods: {
        iniciaFiltro() {
            this.filtro = {
                dataInicial: this.$moment().format('YYYY-MM'),
                dataFinal: this.$moment().format('YYYY-MM'),
                bandeira: [],
                id_espaco: [],
                id_status: [29, 15, 16, 30],
                id_ativacao: [],
                id_categoria: [],
                semana: [],
                id_area: [],
                espaco_macro: [],
                id_usuario_criacao: [],
                visao: ['pdv', 'campanha', 'ecommerce'], // lembrar de remover o pdv
                planejado_realizado: false,
                id_macrofornecedor: [],
                agrupar: [
                    { text: 'Status', value: 'status', ordem: 1 },
                    { text: 'Espaço', value: 'espaco', ordem: 3 },
                ],
            }

            this.resetValidation()
        },
        limpar() {
            this.iniciaFiltro()
            this.$emit('limpar')
        },
        expandirFiltros() {
            this.mostrarFiltros = this.mostrarFiltros == 0 ? null : 0
        },
        periodoInicialChange(valor) {
            if (this.filtro.dataFinal < valor) {
                this.filtro.dataFinal = valor
            }
        },
        periodoFinalChange(valor) {
            if (this.filtro.dataInicial > valor) {
                this.filtro.dataInicial = valor
            }
        },
        filtrar() {
            this.$emit('filtrar')
        },
        validate() {
            return this.$refs.formFiltro.validate()
        },
        resetValidation() {
            try {
                this.$refs.formFiltro.resetValidation()
            } catch (error) {
                //console.log(error)
            }
        },
    },
}
</script>
